import { gql } from '@apollo/client';

export const USER_FRAGMENT = gql`
  fragment UserFields on User {
    id
    email
    displayName
    timeZone
    createdAt
    updatedAt
    spaces {
      id
      name
      slug
    }
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      ...UserFields
    }
  }
  ${USER_FRAGMENT}
`;

export const DOCUMENTS_QUERY = gql`
  query Documents {
    documents {
      path
      title
      type
      updatedAt
      treeLabel
      spaceId
    }
  }
`;

export const DOCUMENT_CONTENT_QUERY = gql`
  query DocumentContent($path: String!) {
    documentContent(path: $path) {
      path
      content
      updatedAt
      version
    }
  }
`;

export const DOCUMENT_VERSIONS_QUERY = gql`
  query DocumentVersions($path: String!) {
    documentVersions(path: $path) {
      version
      author
      createdAt
    }
  }
`;

export const SEARCH_DOCUMENTS_QUERY = gql`
  query SearchDocuments($query: String!) {
    searchDocuments(query: $query) {
      path
      title
      type
      treeLabel
      spaceId
      snippet
    }
  }
`;

export const INSIGHTS_QUERY = gql`
  query Insights {
    insights {
      content
      updatedAt
    }
  }
`;

export const SPACES_QUERY = gql`
  query Spaces {
    spaces {
      id
      name
      slug
      members {
        id
        email
        displayName
      }
      createdAt
      updatedAt
    }
  }
`;

export const SPACE_QUERY = gql`
  query Space($id: ID!) {
    space(id: $id) {
      id
      name
      slug
      members {
        id
        email
        displayName
      }
      createdAt
      updatedAt
    }
  }
`;

export const SYNC_STATUS_QUERY = gql`
  query SyncStatus {
    syncStatus {
      available
      connected
      repoFullName
      branch
      state
      attentionReason
      lastSyncedAt
    }
  }
`;

export const STRAVA_STATUS_QUERY = gql`
  query StravaStatus {
    stravaStatus {
      available
      connected
      athleteName
      lastActivityAt
    }
  }
`;

export const PUSH_STATUS_QUERY = gql`
  query PushStatus {
    pushStatus {
      available
      enabled
      vapidPublicKey
    }
  }
`;

export const CHAT_SESSIONS_QUERY = gql`
  query ChatSessions {
    chatSessions {
      id
      title
      state
      updatedAt
    }
  }
`;

export const CHAT_SESSION_QUERY = gql`
  query ChatSession($id: ID!) {
    chatSession(id: $id) {
      id
      title
      state
      turns {
        role
        text
        citations {
          path
          type
          line
          snippet
        }
        proposals {
          id
          tool
          path
          content
          treeLabel
          spaceId
          ok
          version
          error
        }
        resolution
        at
      }
      pendingProposals {
        id
        tool
        path
        content
        treeLabel
        spaceId
      }
      createdAt
      updatedAt
    }
  }
`;
